export default __webpack_public_path__ + "static/media/mig_site.3e7c9aff.svg";